import styled from 'styled-components'
import theme from './theme'

const ErrorMessage = styled.p`
  color: ${theme.colours.danger1};
  margin-top: 1rem;
`

export default ErrorMessage
